import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import App from "@/App";
import CookieBanner from "@/components/CookieBanner";
import { LanguageProvider } from "@/context/LanguageContext";
import { marketingPages } from "@/content/marketingPages";
import AIEthics from "@/pages/AIEthics";
import Datenschutz from "@/pages/Datenschutz";
import Impressum from "@/pages/Impressum";
import MarketingDetailPage from "@/pages/MarketingDetailPage";

function LocalizedRoute({ language, children }) {
  return (
    <LanguageProvider initialLanguage={language}>
      {children}
      <CookieBanner />
    </LanguageProvider>
  );
}

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <LocalizedRoute language="de">
              <App />
            </LocalizedRoute>
          }
        />
        <Route
          path="/impressum"
          element={
            <LocalizedRoute language="de">
              <Impressum />
            </LocalizedRoute>
          }
        />
        <Route
          path="/datenschutz"
          element={
            <LocalizedRoute language="de">
              <Datenschutz />
            </LocalizedRoute>
          }
        />
        <Route
          path="/ki-ethik"
          element={
            <LocalizedRoute language="de">
              <AIEthics />
            </LocalizedRoute>
          }
        />

        {marketingPages.map((page) => (
          <Route
            key={page.path}
            path={page.path}
            element={
              <LocalizedRoute language="de">
                <MarketingDetailPage />
              </LocalizedRoute>
            }
          />
        ))}

        <Route
          path="/en"
          element={
            <LocalizedRoute language="en">
              <App />
            </LocalizedRoute>
          }
        />
        <Route
          path="/en/impressum"
          element={
            <LocalizedRoute language="en">
              <Impressum />
            </LocalizedRoute>
          }
        />
        <Route
          path="/en/datenschutz"
          element={
            <LocalizedRoute language="en">
              <Datenschutz />
            </LocalizedRoute>
          }
        />
        <Route
          path="/en/ki-ethik"
          element={
            <LocalizedRoute language="en">
              <AIEthics />
            </LocalizedRoute>
          }
        />

        <Route path="/de" element={<Navigate to="/" replace />} />
        <Route path="/de/impressum" element={<Navigate to="/impressum" replace />} />
        <Route path="/de/datenschutz" element={<Navigate to="/datenschutz" replace />} />
        <Route path="/de/ki-ethik" element={<Navigate to="/ki-ethik" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
